// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"az_wob","question":"az_xob","answer":"az_yob","accordionItem":"az_zob"};